import App from '../../components/App';
import props from '../../configs/propsBold';
import StaticBold from '../../sections/static/Bold';

export default function FontGenerator() {
  return (
    <App {...props}>
      <StaticBold />
    </App>
  );
}
